module.exports = __webpack_public_path__ + "img/bp_giftbg_0008.f62e0d4f.png";